import { Badge } from '@/components/ui/badge';

export function StatusBadge({ children, tone = 'neutral' }) {
  return <Badge tone={tone}>{children}</Badge>;
}
